/* EG Collections — Compare Match Config */

window.EG_COLLECTION_COMPARE_MATCH_CONFIG = {
  default: {
    weightedFields: [],
    excludeIfAllMatch: [],
    excludeIfAnyDiff: [],
    scoreAdjusters: [],
    fieldDefs: {},
    requireSameType: true
  },

  collections: {
        "test-collection": {
      weightedFields: [
        { key: "compare_family",    weight: 10 },
        { key: "surface_type",      weight: 6 },
        { key: "surface_material",  weight: 6 },
        { key: "surface_texture",   weight: 6 },
        { key: "surface-coating",   weight: 4 },
        { key: "firmness",          weight: 5 },
        { key: "base-material",     weight: 5 },
        { key: "stitched-edges",    weight: 3 },
        { key: "washable",          weight: 2 },
        { key: "length",            weight: 3 },
        { key: "width",             weight: 3 },
        { key: "thickness",         weight: 2 },
        { key: "area",              weight: 2 },
        { key: "lighting",          weight: 1 },
        { key: "graphics",          weight: 1 },
        { key: "colour",            weight: 1 }
      ],
      excludeIfAllMatch: [
        "compare_family"
      ],
      excludeIfAnyDiff: [],
      scoreAdjusters: [
        { key: "graphics", when: "match", amount: -10 },
        { key: "graphics", when: "diff",  amount: 4 },
        { key: "colour",   when: "match", amount: -18 },
        { key: "colour",   when: "diff",  amount: 3 }
      ],
      fieldDefs: {
        compare_family: {
          startsWith: ["Compare Family__", "Compare Family_", "compare family"]
        }
      },
      requireSameType: true
    },
    "gaming-mousepads": {
      weightedFields: [
        { key: "compare_family",    weight: 10 },
        { key: "surface_type",      weight: 6 },
        { key: "surface_material",  weight: 6 },
        { key: "surface_texture",   weight: 6 },
        { key: "surface-coating",   weight: 4 },
        { key: "firmness",          weight: 5 },
        { key: "base-material",     weight: 5 },
        { key: "stitched-edges",    weight: 3 },
        { key: "washable",          weight: 2 },
        { key: "length",            weight: 3 },
        { key: "width",             weight: 3 },
        { key: "thickness",         weight: 2 },
        { key: "area",              weight: 2 },
        { key: "lighting",          weight: 1 },
        { key: "graphics",          weight: 1 },
        { key: "colour",            weight: 1 }
      ],
      excludeIfAllMatch: [
        "compare_family"
      ],
      excludeIfAnyDiff: [],
      scoreAdjusters: [
        { key: "graphics", when: "match", amount: -10 },
        { key: "graphics", when: "diff",  amount: 4 },
        { key: "colour",   when: "match", amount: -18 },
        { key: "colour",   when: "diff",  amount: 3 }
      ],
      fieldDefs: {
        compare_family: {
          startsWith: ["Compare Family__", "Compare Family_", "compare family"]
        }
      },
      requireSameType: true
    },

    "gaming-mice-used-by-pros": {
      weightedFields: [
        { key: "compare_family",    weight: 10 },
        { key: "shape",             weight: 7 },
        { key: "wired-wireless",    weight: 2 },
        { key: "weight",            weight: 5 },
        { key: "sensor-model",      weight: 4 },
        { key: "polling-rate",      weight: 4 },
        { key: "buttons",           weight: 4 },
        { key: "grip-style",        weight: 4 },
        { key: "shell",             weight: 3 },
        { key: "length",            weight: 3 },
        { key: "width",             weight: 3 },
        { key: "height",            weight: 3 },
        { key: "wired-wireless",    weight: 2 },
        { key: "connection",        weight: 2 },
        { key: "battery-life",      weight: 2 },
        { key: "switches",          weight: 2 },
        { key: "cpi-dpi",           weight: 1 }
      ],
      excludeIfAllMatch: [
        "compare_family"
      ],
      excludeIfAnyDiff: [],
      scoreAdjusters: [],
      fieldDefs: {
        compare_family: {
          startsWith: ["Compare Family__", "Compare Family_", "compare family"]
        }
      },
      requireSameType: true
    },

    "mice-skates": {
      weightedFields: [
        { key: "compare_family",   weight: 10 },
        { key: "material",         weight: 6 },
        { key: "glide",            weight: 5 },
        { key: "surface_comp",     weight: 4 },
        { key: "comp_with",        weight: 4 },
        { key: "thickness",        weight: 3 },
        { key: "rounded_edges",    weight: 3 }
      ],
      excludeIfAllMatch: [
        "compare_family"
      ],
      excludeIfAnyDiff: [],
      scoreAdjusters: [],
      fieldDefs: {
        compare_family: {
          startsWith: ["Compare Family__", "Compare Family_", "compare family"]
        }
      },
      requireSameType: true
    },

    "grip-tape": {
      weightedFields: [
        { key: "compare_family",   weight: 10 },
        { key: "material",         weight: 6 },
        { key: "comp_with",        weight: 5 },
        { key: "thickness",        weight: 4 },
        { key: "flatten_edges",    weight: 3 }
      ],
      excludeIfAllMatch: [
        "compare_family"
      ],
      excludeIfAnyDiff: [],
      scoreAdjusters: [],
      fieldDefs: {
        compare_family: {
          startsWith: ["Compare Family__", "Compare Family_", "compare family"]
        }
      },
      requireSameType: true
    },

    "arm-sleeves": {
      weightedFields: [
        { key: "compare_family",   weight: 10 },
        { key: "material",         weight: 6 },
        { key: "size",             weight: 5 },
        { key: "sleeve-length",    weight: 4 },
        { key: "style",            weight: 3 },
        { key: "colour",           weight: 1 }
      ],
      excludeIfAllMatch: [
        "compare_family"
      ],
      excludeIfAnyDiff: [],
      scoreAdjusters: [
        { key: "colour", when: "match", amount: -10 },
        { key: "colour", when: "diff",  amount: 2 }
      ],
      fieldDefs: {
        compare_family: {
          startsWith: ["Compare Family__", "Compare Family_", "compare family"]
        }
      },
      requireSameType: true
    }
  },

  types: {
  mice: {
    weightedFields: [
      { key: "compare_family", weight: 10 },
      { key: "shape",          weight: 8 },
      { key: "size",           weight: 6 },
      { key: "weight",         weight: 6 },
      { key: "length",         weight: 4 },
      { key: "width",          weight: 4 },
      { key: "height",         weight: 4 },
      { key: "sensor-model",   weight: 4 },
      { key: "polling-rate",   weight: 4 },
      { key: "grip-style",     weight: 3 },
      { key: "buttons",        weight: 3 },
      { key: "switches",       weight: 3 },
      { key: "wired-wireless", weight: 3 },
      { key: "connection",     weight: 2 },
      { key: "battery-life",   weight: 2 },
      { key: "cpi-dpi",        weight: 1 }
    ],
    excludeIfAllMatch: ["compare_family"],
    excludeIfAnyDiff: [],
    scoreAdjusters: [],
    fieldDefs: {
      compare_family: {
        startsWith: ["Compare Family__", "Compare Family_", "compare family"]
      }
    },
    requireSameType: true
  },

  keyboards: {
    weightedFields: [
      { key: "compare_family",  weight: 10 },
      { key: "layout",          weight: 8 },
      { key: "switch-type",     weight: 6 },
      { key: "switches",        weight: 5 },
      { key: "wired-wireless",  weight: 5 },
      { key: "connection",      weight: 4 },
      { key: "length",          weight: 4 },
      { key: "width",           weight: 4 },
      { key: "height",          weight: 3 },
      { key: "weight",          weight: 3 },
      { key: "keycaps",         weight: 3 },
      { key: "key-rollover",    weight: 2 },
      { key: "backlit",         weight: 2 },
      { key: "macro-keys",      weight: 2 },
      { key: "media-keys",      weight: 2 },
      { key: "wrist-rest",      weight: 1 },
      { key: "usb-hub",         weight: 1 }
    ],
    excludeIfAllMatch: ["compare_family"],
    excludeIfAnyDiff: [],
    scoreAdjusters: [],
    fieldDefs: {
      compare_family: {
        startsWith: ["Compare Family__", "Compare Family_", "compare family"]
      }
    },
    requireSameType: true
  },

  headsets: {
    weightedFields: [
      { key: "compare_family", weight: 10 },
      { key: "connectivity",   weight: 6 },
      { key: "wired-wireless", weight: 6 },
      { key: "audio_type",     weight: 5 },
      { key: "mic_type",       weight: 4 },
      { key: "conn_type",      weight: 3 },
      { key: "connection",     weight: 3 },
      { key: "compatibility",  weight: 2 }
    ],
    excludeIfAllMatch: ["compare_family"],
    excludeIfAnyDiff: [],
    scoreAdjusters: [],
    fieldDefs: {
      compare_family: {
        startsWith: ["Compare Family__", "Compare Family_", "compare family"]
      }
    },
    requireSameType: true
  },

  microphones: {
    weightedFields: [
      { key: "compare_family", weight: 10 },
      { key: "mic_type",       weight: 7 },
      { key: "connectivity",   weight: 6 },
      { key: "wired-wireless", weight: 6 },
      { key: "conn_type",      weight: 4 },
      { key: "connection",     weight: 4 },
      { key: "freq_response",  weight: 3 }
    ],
    excludeIfAllMatch: ["compare_family"],
    excludeIfAnyDiff: [],
    scoreAdjusters: [],
    fieldDefs: {
      compare_family: {
        startsWith: ["Compare Family__", "Compare Family_", "compare family"]
      }
    },
    requireSameType: true
  },

  earphones: {
    weightedFields: [
      { key: "compare_family", weight: 10 },
      { key: "connectivity",   weight: 6 },
      { key: "wired-wireless", weight: 6 },
      { key: "mic_type",       weight: 4 },
      { key: "conn_type",      weight: 4 },
      { key: "connection",     weight: 4 }
    ],
    excludeIfAllMatch: ["compare_family"],
    excludeIfAnyDiff: [],
    scoreAdjusters: [],
    fieldDefs: {
      compare_family: {
        startsWith: ["Compare Family__", "Compare Family_", "compare family"]
      }
    },
    requireSameType: true
  },

  "mouse feet": {
    weightedFields: [
      { key: "compare_family", weight: 10 },
      { key: "material",       weight: 7 },
      { key: "glide",          weight: 6 },
      { key: "surface_comp",   weight: 5 },
      { key: "comp_with",      weight: 5 },
      { key: "thickness",      weight: 4 },
      { key: "rounded_edges",  weight: 3 }
    ],
    excludeIfAllMatch: ["compare_family"],
    excludeIfAnyDiff: [],
    scoreAdjusters: [],
    fieldDefs: {
      compare_family: {
        startsWith: ["Compare Family__", "Compare Family_", "compare family"]
      }
    },
    requireSameType: true
  },

  keycaps: {
    weightedFields: [
      { key: "compare_family", weight: 10 },
      { key: "layout",         weight: 7 },
      { key: "compatibility",  weight: 6 },
      { key: "material",       weight: 5 },
      { key: "keys",           weight: 4 },
      { key: "legends",        weight: 3 },
      { key: "legend",         weight: 3 },
      { key: "backlit",        weight: 2 }
    ],
    excludeIfAllMatch: ["compare_family"],
    excludeIfAnyDiff: [],
    scoreAdjusters: [],
    fieldDefs: {
      compare_family: {
        startsWith: ["Compare Family__", "Compare Family_", "compare family"]
      }
    },
    requireSameType: true
  },

  "wrist rests": {
    weightedFields: [
      { key: "compare_family", weight: 10 },
      { key: "layout",         weight: 7 },
      { key: "length",         weight: 5 },
      { key: "width",          weight: 5 },
      { key: "height",         weight: 4 },
      { key: "base",           weight: 5 },
      { key: "weight",         weight: 3 },
      { key: "colour",         weight: 1 }
    ],
    excludeIfAllMatch: ["compare_family"],
    excludeIfAnyDiff: [],
    scoreAdjusters: [
      { key: "colour", when: "match", amount: -8 },
      { key: "colour", when: "diff",  amount: 2 }
    ],
    fieldDefs: {
      compare_family: {
        startsWith: ["Compare Family__", "Compare Family_", "compare family"]
      }
    },
    requireSameType: true
  },

  controllers: {
    weightedFields: [
      { key: "compare_family", weight: 10 },
      { key: "connectivity",   weight: 6 },
      { key: "wired-wireless", weight: 6 },
      { key: "compatibility",  weight: 5 },
      { key: "conn_type",      weight: 4 },
      { key: "connection",     weight: 4 },
      { key: "dpad",           weight: 3 },
      { key: "circular-d-pad", weight: 3 }
    ],
    excludeIfAllMatch: ["compare_family"],
    excludeIfAnyDiff: [],
    scoreAdjusters: [],
    fieldDefs: {
      compare_family: {
        startsWith: ["Compare Family__", "Compare Family_", "compare family"]
      }
    },
    requireSameType: true
  }
}
 
};